import React, { Fragment, useEffect, useState } from 'react'
import FsLightbox from 'fslightbox-react';

import { Row, Col, Image, Nav, Tab, OverlayTrigger, Popover, Badge, Tooltip, Modal, Button } from 'react-bootstrap'
import Card from '../../../components/Card'

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
// img

import avatars11 from '../../../assets/images/avatars/01.png'
import avatars22 from '../../../assets/images/avatars/avtar_1.png'
import avatars33 from '../../../assets/images/avatars/avtar_2.png'
import avatars44 from '../../../assets/images/avatars/avtar_3.png'
import avatars55 from '../../../assets/images/avatars/avtar_4.png'
import avatars66 from '../../../assets/images/avatars/avtar_5.png'
import avatars2 from '../../../assets/images/avatars/02.png'
import avatars3 from '../../../assets/images/avatars/03.png'
import avatars4 from '../../../assets/images/avatars/04.png'
import avatars5 from '../../../assets/images/avatars/05.png'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import avatar1 from "../../../assets/images/avatars/01.png"

import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import pages2 from '../../../assets/images/pages/02-page.png'

import ShareOffcanvas from '../../../components/partials/components/shareoffcanvas'
import { userSignal } from '../../../signal/userSignal';
import * as moment from 'moment';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { DEV_SERVER } from '../../../constants/urls';
import axios from 'axios';
import TripListOfUser from '../trips/TripListOfUser';
import PerformanceChart from '../trips/performance-chart';
import Attendence from '../attendence/Attendence';
import ExpenseListOfUser from '../expenses/ExpenseListOfUser';
import LeavesListOfUser from '../leaves/LeaveListOfUser';
import Circularprogressbar from '../../../components/circularprogressbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from "swiper";
import { userExcelGenerator } from '../../../utilities/excelGenerator';
import ExcelExport from "../../../assets/images/icons/excel-export.svg"
import { organisationSignal } from '../../../signal/organisationSignal';
import Avatar from 'react-avatar';
import CountUp from 'react-countup';
import DataTable from 'react-data-table-component';
import { allUsersSignal } from '../../../signal/allUsersSignal';
import AccStatement from './AccStatement';

// install Swiper modules
SwiperCore.use([Navigation]);

const FarmerProfile = (props) => {

    let today = new Date()
    today = new Date(today).getTime();
    // get date start Time of month's first day
    let monthStartDay = new Date(new Date(today).getFullYear(), new Date(today).getMonth(), 1).getTime();
    const [searchParams, setSearchParams] = useSearchParams();
    const [toggler, setToggler] = useState();
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(monthStartDay).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [visits, setVisits] = useState([]);
    const [Farmer, setFarmer] = useState({});
    const [visitPage, setVisitPage] = useState(1);
    const [visitPerPage, setVisitPerPage] = useState(35);
    const [visitSummary, setVisitSummary] = useState(0);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [cropData, setCropData] = useState([]);
    const [demonstrationData, setDemonstrationData] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [suggestionTotal, setSuggestionTotal] = useState(0);
    const [suggestionPage, setSuggestionPage] = useState(1);
    const [suggestionPerPage, setSuggestionPerPage] = useState(20);
    const [farmerFields, setFarmerFields] = useState([]);
    const [farmerFieldPage, setFarmerFieldPage] = useState(1);
    const [farmerFieldPerPage, setFarmerFieldPerPage] = useState(20);
    const [farmerFieldTotal, setFarmerFieldTotal] = useState(0);
    const [showFarmerFieldModal, setShowFarmerFieldModal] = useState(false);
    const [selectedFarmerField, setSelectedFarmerField] = useState(null);

    const url = useLocation();
    const navigate = useNavigate();
    const id = url.pathname.split("/")[3];

    const getVariableColor = () => {
        let prefix =
            getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
        if (prefix) {
            prefix = prefix.trim();
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary`
        );
        const color2 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}info`
        );
        const color3 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary-tint-20`
        );
        const color4 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}warning`
        );
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    };
    const variableColors = getVariableColor();

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
        return () => colors;
    });

    const FarmerDetails = useQuery("FarmerDetails", async () => {
        let resp = await axios.get(`${DEV_SERVER}/farmer/v2/${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setFarmer(data.data);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            console.log(error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");

            }
            navigate("/dashboard/Farmers");
        }
    })

    const getSuggestionsQuery = useQuery(["FarmerSuggestions", id, suggestionPage, suggestionPerPage], async ({ signal }) => {
        const params = new URLSearchParams({
            farmerId: id,
            page: suggestionPage,
            limit: suggestionPerPage,
        });
        let resp = await axios.get(`${DEV_SERVER}/suggestion/v2/?${params.toString()}`, {
            headers: { Authorization: `Bearer ${userSignal.value?.token}` },
            signal,
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setSuggestions(data.data || []);
                setSuggestionTotal(data.data?.length || 0);
            } else {
                toast.error(data.message);
            }
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Something went wrong");
        }
    })

    const getVisits = useQuery(["FarmerVisits", id, visitPage, visitPerPage, fromDate, toDate], async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/trip/v2/task/getFarmerVisits?page=${visitPage}&perPage=${visitPerPage}&startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 59)}&farmerId=${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: !!id,
        onSuccess: (data) => {
            if (data.status) {
                setVisits(data.data?.data || []);
                setVisitPage(data.data?.page || 1);
                setVisitPerPage(data.data?.perPage || 35);
                setVisitSummary(data.data?.totalItems || 0);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const getFarmerFieldsQuery = useQuery("FarmerFields", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/farmerfield/v2?farmerId=${id}&page=${farmerFieldPage}&limit=${farmerFieldPerPage}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setFarmerFields(data.data?.data || []);
                setFarmerFieldPage(data.data?.pagination?.page || 1);
                setFarmerFieldPerPage(data.data?.pagination?.limit || 20);
                setFarmerFieldTotal(data.data?.pagination?.total || 0);
            } else {
                toast.error(data.message);
            }
        },
        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const visitRefetch = () => {
        getVisits.refetch({ cancelRefetch: true });
    }

    const farmerFieldRefetch = () => {
        getFarmerFieldsQuery.refetch({ cancelRefetch: true });
    }

    useEffect(() => {
        FarmerDetails.refetch({ cancelRefetch: true });
        getVisits.refetch({ cancelRefetch: true });
        getFarmerFieldsQuery.refetch({ cancelRefetch: true });
        getSuggestionsQuery.refetch({ cancelRefetch: true });
    }, [])

    useEffect(() => {
        if (farmerFieldPage > 0 && farmerFieldPerPage > 0) {
            getFarmerFieldsQuery.refetch({ cancelRefetch: true });
        }
    }, [farmerFieldPage, farmerFieldPerPage])


    const handleDateChange = () => {
        let tempSearch = new URLSearchParams({ fromDate: fromDate, toDate: toDate });
        setSearchParams(tempSearch);
        getVisits.refetch({ cancelRefetch: true });
    }


    const visitsColumns = [
        {
            name: "Title",
            selector: "tasks.title",
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.tasks?.title}</Tooltip>}>
                    <span>{row?.tasks?.title}</span>
                </OverlayTrigger>
            },
            center: true,
        },
        {
            name: "Description",
            selector: "tasks.description",
            center: true,
            cell: (row) => {
                return row?.tasks?.description === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.tasks?.description}</Tooltip>}>
                    <span>{row?.tasks?.description}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Status",
            selector: (row) => {
                return row?.tasks?.status === "pending" ? <Badge bg="warning">{row?.tasks?.status}</Badge> : <Badge bg="success">{row?.tasks?.status}</Badge>
            },
            center: true,
            width: "100px"
        },
        {
            name: "Remarks",
            selector: "tasks.remarks",
            center: true,
            cell: (row) => {
                return row?.tasks?.remarks === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.tasks?.remarks}</Tooltip>}>
                    <span>{row?.tasks?.remarks}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Remark image",
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.tasks?.media?.length > 0 && row?.tasks?.media.map((url, index) =>
                    <Zoom key={index}><img src={url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>
                )}
            </div>
        },
        {
            name: "Address",
            selector: (row) => {
                // Build address parts array, filtering out empty/undefined values
                const addressParts = [
                    row?.tasks?.destinationArea,
                    row?.tasks?.destinationCity,
                    row?.tasks?.destinationState
                ].filter(part => part && part !== "");

                // Join valid parts with comma separator
                const address = addressParts.join(", ");

                return <OverlayTrigger placement="top" overlay={
                    <Tooltip style={{ position: "fixed" }}>
                        {address || "No address available"}
                    </Tooltip>
                }>
                    <span>{address || "No address available"}</span>
                </OverlayTrigger>
            },
            width: "300px",
            center: true,
        },
        {
            name: "User",
            selector: (row) => {
                if (row?.user?._id) {
                    return (
                        <div style={{ columnGap: "0.4rem" }}>
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {row?.user?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{row?.user?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            },
            center: true,
            width: "150px"
        },
        {
            name: "Completed Location",
            width: "100px",
            selector: (row) => {
                return <span className="d-flex justify-content-between align-items-start" style={{ columnGap: "0.5rem" }}>
                    {(row?.tasks?.completedAt === "" || row?.tasks?.completedAt === null || row?.tasks?.completedAt === undefined || row?.tasks?.completedAt === 0) ? "-" :
                        <span className="d-flex flex-column">
                            <p className="mb-1">{moment(row?.tasks?.completedAt).format("DD/MM/YY")}</p>
                            <p className="mb-0" style={{ color: "rgba(0, 0, 0, 0.625)", fontSize: "10px" }}>{moment(row?.tasks?.completedAt).format("hh:mm A")}</p>
                        </span>
                    }

                    {row?.tasks?.completedAtLocation?.length > 0 && <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.tasks?.completedAtLocation[0]},${row?.tasks?.completedAtLocation[1]}`} target="_blank" ><i className="fas fa-map-marker-alt"></i></a></OverlayTrigger>}

                </span>
            },
            center: true,
        }
    ]

    const farmerFieldsColumns = [
        {
            name: "Village",
            selector: (row) => row?.Village || "N/A",
            sortable: true,
            center: true,
        },
        {
            name: "Crop Name",
            selector: (row) => row?.CropName || "N/A",
            sortable: true,
            center: true,
        },
        {
            name: "Land Holding (Acres)",
            selector: (row) => row?.LandHoldingAcres || 0,
            sortable: true,
            center: true,
        },
        {
            name: "District",
            selector: (row) => row?.District || "N/A",
            sortable: true,
            center: true,
        },
        {
            name: "Field Visit",
            selector: (row) => row?.FieldVisit ? moment(parseInt(row.FieldVisit)).format("DD/MM/YY") : "N/A",
            sortable: true,
            center: true,
        },
        {
            name: "User",
            selector: (row) => {
                if (row?.userId?.name) {
                    return (
                        <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.userId?.name}</Tooltip>}>
                            <span>{row?.userId?.name}</span>
                        </OverlayTrigger>
                    )
                }
                return "N/A"
            },
            center: true,
        },
        {
            name: "Created At",
            selector: (row) => row?.createdAt ? moment(parseInt(row.createdAt)).format("DD/MM/YY hh:mm A") : "N/A",
            sortable: true,
            center: true,
        },
        {
            name: "Actions",
            center: true,
            cell: (row) => (
                <Button 
                    size="sm" 
                    variant="primary"
                    onClick={() => {
                        setSelectedFarmerField(row);
                        setShowFarmerFieldModal(true);
                    }}
                >
                    View Details
                </Button>
            ),
            width: "150px"
        },
    ]

    const calculateOutStandings = () => {
        try {
            let tallyDetails = Farmer?.tallyDetails
            let totalOutstanding = 0

            if (tallyDetails) {
                for (let i = 0; i < tallyDetails.length; i++) {
                    totalOutstanding += tallyDetails[i].outstanding
                }
                return totalOutstanding
            } else {
                return Farmer?.outStanding || 0
            }

        } catch (err) {
            return Farmer?.outStanding || 0
        }
    }

    const getOutStandings = () => {
        let resp = calculateOutStandings()

        return {
            totalOutstanding: resp,
            formatedOutstanding: `₹ ${resp < 0 ? '-' : ''}${Math.abs(resp) > 1000 ? parseFloat(Math.abs(resp) / 1000).toFixed(2) + "K" : parseFloat(Math.abs(resp)).toFixed(2)}`
        }

    }

    const fetchDetailsData = async () => {
        setLoadingDetails(true);
        try {
            const headers = {
                Authorization: `Bearer ${userSignal.value?.token}`,
            };

            const [cropResponse, demoResponse] = await Promise.all([
                axios.get(`${DEV_SERVER}/activities/v2/crop-data?farmerId=${id}`, { headers }),
                axios.get(`${DEV_SERVER}/activities/v2/demonstration?farmerId=${id}`, { headers })
            ]);

            setCropData(cropResponse.data?.data || []);
            setDemonstrationData(demoResponse.data?.data || []);
        } catch (error) {
            console.error('Error fetching details:', error);
            toast.error('Failed to fetch details data');
        } finally {
            setLoadingDetails(false);
        }
    };

    return (
        <Fragment>
            <FsLightbox
                toggler={toggler}
                sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
            />
            {(FarmerDetails.isLoading) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-primary m-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div> :
                <Tab.Container defaultActiveKey="first">
                    <Row>
                        <Col lg="12" style={{ marginTop: "3rem" }}>
                            <Card>
                                <Card.Body>
                                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                                        <div className="d-flex flex-wrap align-items-center">
                                            <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                                                {(Farmer?.visitingCard?.length && Farmer?.visitingCard?.length !== 0) ? <Image className="rounded-circle img-fluid avatar-100" src={Farmer?.visitingCard[0]?.url} alt="profile-img" /> : <>
                                                    <Avatar name={Farmer?.name} round style={{ borderRadius: "50% !important", margin: "0px auto", position: "relative", width: "200px !important", height: "200px !important" }} />
                                                </>}
                                            </div>
                                            <div className='d-flex flex-column'>
                                                <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                                                    <h4 className="me-2 h4">{Farmer?.name}</h4>
                                                </div>
                                                <div className="d-flex flex-wrap align-items-center">
                                                    {Farmer?.phoneNumber}
                                                </div>
                                            </div>

                                        </div>
                                        <div className='d-flex flex-column justify-self-right'>
                                            <h2 className={`counter text-${getOutStandings()?.totalOutstanding < 0 ? "danger" : "success"}`} >{getOutStandings()?.formatedOutstanding}</h2>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg="12">
                            <Card>
                                <Card.Body>
                                    <Row className="row-cols-1">
                                        <div className="d-slider1 ">
                                            <Swiper
                                                className="p-0 m-0 mb-2 list-inline "
                                                slidesPerView={5}
                                                spaceBetween={32}
                                                navigation={{
                                                    nextEl: ".swiper-button-next",
                                                    prevEl: ".swiper-button-prev",
                                                }}
                                                breakpoints={{
                                                    320: { slidesPerView: 1 },
                                                    550: { slidesPerView: 2 },
                                                    991: { slidesPerView: 3 },
                                                    1400: { slidesPerView: 3 },
                                                    1500: { slidesPerView: 4 },
                                                    1920: { slidesPerView: 4 },
                                                    2040: { slidesPerView: 7 },
                                                    2440: { slidesPerView: 8 }
                                                }}

                                            >
                                                 <SwiperSlide className=" card card-slide" >
                                                     <div className="card-body">
                                                         <div className="progress-widget">
                                                             <Circularprogressbar
                                                                 stroke={variableColors.primary}
                                                                 width="60px"
                                                                 height="60px"
                                                                 Linecap="rounded"
                                                                 trailstroke="#ddd"
                                                                 strokewidth="4px"
                                                                 style={{ width: 60, height: 60 }}
                                                                 value={90}
                                                                 id="circle-progress-02"
                                                             >
                                                                 {suggestionTotal === 0 ?
                                                                     <svg className="" width="24" height="24" viewBox="0 0 24 24">
                                                                         <path fill="currentColor" d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z" />
                                                                     </svg> :
                                                                     <svg className="" width="24" height="24px" viewBox="0 0 24 24">
                                                                         <path fill="currentColor" d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z" />
                                                                     </svg>}
                                                             </Circularprogressbar>
                                                             <div className="progress-detail">
                                                                 <p className="mb-2">Total Suggestions</p>
                                                                 <h4 className="counter">{suggestionTotal}</h4>
                                                             </div>
                                                         </div>
                                                     </div>
                                                 </SwiperSlide>
                                                <SwiperSlide className=" card card-slide">
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.info}
                                                                width="60px"
                                                                height="60px"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                Linecap="rounded"
                                                                style={{ width: 60, height: 60 }}
                                                                value={60}
                                                                id="circle-progress-04"
                                                            >
                                                                {visitSummary === 0 ?
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                        />
                                                                    </svg> :
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24px"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                        />
                                                                    </svg>}
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Visits</p>
                                                                <h4 className="counter">
                                                                    {visitSummary}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>

                                                <div className="swiper-button swiper-button-next"></div>
                                                <div className="swiper-button swiper-button-prev"></div>
                                            </Swiper>
                                        </div>
                                    </Row>
                                    <div style={{ display: "flex", alignItems: "start", columnGap: "1rem", marginBottom: "1rem" }}>
                                        <div style={{ display: "flex", alignItems: "start", columnGap: "1rem", marginBottom: "1rem" }}>
                                            <div>
                                                <label htmlFor="fromDate">From Date</label>
                                                <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                            </div>
                                            <div>
                                                <label htmlFor="toDate">To Date</label>
                                                <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                            </div>
                                            <button className='btn btn-primary align-self-end' onClick={handleDateChange}>Submit</button>
                                        </div>
                                        <div style={{ alignSelf: "flex-start", flexGrow: 1 }} className="d-flex align-items-start justify-content-end">
                                            <OverlayTrigger trigger="click" placement="left" overlay={
                                                <Popover
                                                    id="popover-basic"
                                                    placement="left"
                                                    title=""
                                                >
                                                    <Card className="mb-0">
                                                        <Card.Header>
                                                            <div className="header-title">
                                                                <h4 className="card-title">About</h4>
                                                            </div>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            {Farmer?.name && <div className="mb-2">Farmer Name: <span className="ms-3">{Farmer?.name}</span></div>}
                                                            {Farmer?.phoneNumber && <div className="mb-2">Phone Number: <span className="ms-3">{Farmer?.phoneNumber}</span></div>}
                                                            {Farmer?.email && <div className="mb-2">Email: <span className="ms-3">{Farmer?.email}</span></div>}
                                                            {Farmer?.address && <div className="mb-2">Address: <span className="ms-3">{Farmer?.address}</span></div>}
                                                            {Farmer?.city && <div className="mb-2">City: <span className="ms-3">{Farmer?.city}</span></div>}
                                                            {Farmer?.state && <div className="mb-2">State: <span className="ms-3">{Farmer?.state}</span></div>}
                                                            {Farmer?.pincode && <div className="mb-2">Pincode: <span className="ms-3">{Farmer?.pincode}</span></div>}
                                                            {Farmer?.landHolding && <div className="mb-2">Land Holding (Acres): <span className="ms-3">{Farmer?.landHolding}</span></div>}
                                                            {Farmer?.group && <div className="mb-2">Group: <span className="ms-3">{Farmer?.group}</span></div>}
                                                        </Card.Body>
                                                    </Card>
                                                </Popover>
                                            }>
                                                <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.334 2.75H7.665C4.644 2.75 2.75 4.889 2.75 7.916V16.084C2.75 19.111 4.635 21.25 7.665 21.25H16.333C19.364 21.25 21.25 19.111 21.25 16.084V7.916C21.25 4.889 19.364 2.75 16.334 2.75Z" stroke="#096DD9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M11.9946 16V12" stroke="#096DD9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M11.9896 8.2041H11.9996" stroke="#096DD9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <Nav as="ul" className="d-flex nav-pills mb-0 text-center profile-tab" data-toggle="slider-tab" id="profile-pills-tab" role="tablist">
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="first">Suggestions</Nav.Link>
                                            </Nav.Item>
                                            {(organisationSignal?.value?.isTallyIntegrationActivated && Farmer?.isTallyFarmer === true) && <Nav.Item as="li">
                                                <Nav.Link eventKey="third">Acc Statement</Nav.Link>
                                            </Nav.Item>}
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="fourth">Visits</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="fifth">Farmer Fields</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item as="li">
                                            <Nav.Link eventKey="fourth">Profile</Nav.Link>
                                        </Nav.Item> */}
                                        </Nav>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Tab.Content className="profile-content">
                                {<Tab.Pane eventKey="first" id="profile-suggestions">
                                    {(getSuggestionsQuery?.isLoading || getSuggestionsQuery?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div> :
                                        <Row>
                                            <Col sm="12">
                                                <Card>
                                                    <Card.Header className="d-flex justify-content-between">
                                                        <div className="header-title">
                                                            <h4 className="card-title">Suggestions</h4>
                                                        </div>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <DataTable
                                                            columns={[
                                                                {
                                                                    name: "Stage",
                                                                    center: true,
                                                                    width: "120px",
                                                                    selector: (row) => (
                                                                        <Badge bg={row?.currentStage === "Approved" ? "success" : row?.currentStage === "Rejected" ? "danger" : "warning"}>
                                                                            {row?.currentStage || "Pending"}
                                                                        </Badge>
                                                                    ),
                                                                },
                                                                {
                                                                    name: "Items",
                                                                    center: true,
                                                                    selector: (row) => row?.suggestionItems?.length || 0,
                                                                },
                                                                {
                                                                    name: "Total Amount",
                                                                    center: true,
                                                                    selector: (row) => `₹ ${parseFloat(row?.totalAmount || 0).toFixed(2)}`,
                                                                },
                                                                {
                                                                    name: "Note",
                                                                    center: true,
                                                                    selector: (row) => row?.note || "—",
                                                                },
                                                                {
                                                                    name: "Created At",
                                                                    center: true,
                                                                    selector: (row) => moment(row?.createdAt).format("DD/MM/YY hh:mm A"),
                                                                },
                                                                {
                                                                    name: "Action",
                                                                    center: true,
                                                                    selector: (row) => (
                                                                        <span
                                                                            style={{ cursor: "pointer", color: "#0d6efd" }}
                                                                            onClick={() => navigate(`/dashboard/suggestions/${row?.id || row?._id}`)}
                                                                        >
                                                                            <i className="far fa-eye"></i>
                                                                        </span>
                                                                    ),
                                                                },
                                                            ]}
                                                            data={suggestions}
                                                            pagination
                                                            paginationServer
                                                            paginationTotalRows={suggestionTotal}
                                                            paginationPerPage={suggestionPerPage}
                                                            paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                                            paginationDefaultPage={suggestionPage}
                                                            onChangeRowsPerPage={(n) => setSuggestionPerPage(n)}
                                                            onChangePage={(p) => setSuggestionPage(p)}
                                                            onRowClicked={(row) => navigate(`/dashboard/suggestions/${row?.id || row?._id}`)}
                                                            customStyles={{ rows: { style: { cursor: "pointer", backgroundColor: "unset" } } }}
                                                            noDataComponent={<div className="p-3 text-muted">No suggestions for this farmer.</div>}
                                                        />
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    }
                                </Tab.Pane >}
                                {(organisationSignal?.value?.isTallyIntegrationActivated && Farmer?.isTallyFarmer === true) && <Tab.Pane eventKey={"third"} id="profile-accStatement">
                                    <AccStatement FarmerId={Farmer?.id} FarmerName={Farmer?.name} />
                                </Tab.Pane>}
                                {<Tab.Pane eventKey="fourth" id="profile-activity">
                                    {(getVisits?.isLoading || getVisits?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> :
                                        <div>
                                            <Row>
                                                <Col sm="12">
                                                    <Card>
                                                        <Card.Header className="d-flex justify-content-between">
                                                            <div className="header-title">
                                                                <h4 className="card-title">Visits</h4>
                                                            </div>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <DataTable
                                                                customStyles={{ cells: "center" }} columns={visitsColumns} data={visits} pagination={true}
                                                                paginationServer={true} paginationTotalRows={visitSummary} paginationPerPage={visitPerPage} paginationRowsPerPageOptions={[10, 20, 30, 35, 40, 50]}
                                                                paginationDefaultPage={visitPage}
                                                                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                                                    setVisitPerPage(currentRowsPerPage);
                                                                }
                                                                } onChangePage={(currentPage) => {
                                                                    setVisitPage(currentPage);
                                                                }}
                                                            />
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>
                                    }
                                </Tab.Pane >}
                                {<Tab.Pane eventKey="fifth" id="profile-farmer-fields">
                                    {(getFarmerFieldsQuery?.isLoading || getFarmerFieldsQuery?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> :
                                        <div>
                                            <Row>
                                                <Col sm="12">
                                                    <Card>
                                                        <Card.Header className="d-flex justify-content-between">
                                                            <div className="header-title">
                                                                <h4 className="card-title">Farmer Fields</h4>
                                                            </div>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <DataTable
                                                                customStyles={{ cells: "center" }} 
                                                                columns={farmerFieldsColumns} 
                                                                data={farmerFields} 
                                                                pagination={true}
                                                                paginationServer={true} 
                                                                paginationTotalRows={farmerFieldTotal} 
                                                                paginationPerPage={farmerFieldPerPage} 
                                                                paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                                                paginationDefaultPage={farmerFieldPage}
                                                                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                                                    setFarmerFieldPerPage(currentRowsPerPage);
                                                                    getFarmerFieldsQuery.refetch({ cancelRefetch: true });
                                                                }}
                                                                onChangePage={(currentPage) => {
                                                                    setFarmerFieldPage(currentPage);
                                                                    getFarmerFieldsQuery.refetch({ cancelRefetch: true });
                                                                }}
                                                            />
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>
                                    }
                                </Tab.Pane >}
                                {/* <Tab.Pane eventKey="fourth" id="profile-activity">
                                    {(expensesMutation?.isLoading || expensesMutation?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> : <ExpenseListOfUser expenses={expenses} expenseRefetch={expenseRefetch} />}
                                </Tab.Pane >
                                <Tab.Pane eventKey="fifth" id="profile-activity">
                                    {(expensesMutation?.isLoading || expensesMutation?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> : <LeavesListOfUser leaves={leaves} leaveRefetch={leaveRefetch} />}
                                </Tab.Pane >
                                <Tab.Pane eventKey="sixth" id="profile-friends">
                                    {(employeeAttendence.isLoading || employeeAttendence?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden tets2">Loading...</span>
                                        </div>
                                    </div> : <Attendence attendences={attendences} fromDate={fromDate} toDate={toDate} />}
                                </Tab.Pane > */}
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            }

            {/* Farmer Field Details Modal */}
       <Modal show={showFarmerFieldModal} onHide={() => setShowFarmerFieldModal(false)} size="xl">
    <Modal.Header closeButton style={{ backgroundColor: '#fff', color: 'white', borderBottom: 'none' }}>
        <Modal.Title>Farmer Field Details</Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
        {selectedFarmerField && (
            <Row>
                {/* Field Visit Information */}
                <Col md={6}>
                    <Card className="mb-3 shadow-sm border-0">
                        <Card.Header style={{ backgroundColor: '#096dd9', color: 'white', padding: '12px 20px' }}>
                            <h6 className="mb-0 d-flex align-items-center">
                                <i className="fas fa-map-marker-alt me-2"></i>
                                Field Visit Information
                            </h6>
                        </Card.Header>
                        <Card.Body style={{ backgroundColor: 'white' }}>
                            <table className="table table-sm table-borderless mb-0">
                                <tbody>
                                    {selectedFarmerField.userId?.name && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{width: '45%', paddingTop: '8px', paddingBottom: '8px'}}>Created By:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.userId.name}</td>
                                        </tr>
                                    )}
                                    {(selectedFarmerField.createdAt || selectedFarmerField.FieldVisit) && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{width: '45%', paddingTop: '8px', paddingBottom: '8px'}}>Field Visit Date:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.createdAt ? moment(parseInt(selectedFarmerField.createdAt)).format("DD/MM/YYYY hh:mm A") : (selectedFarmerField.FieldVisit ? moment(parseInt(selectedFarmerField.FieldVisit)).format("DD/MM/YYYY hh:mm A") : "N/A")}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.FarmerName && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Farmer Name:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.FarmerName}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.Village && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Village:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Village}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.Tehsil && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Tehsil:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Tehsil}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.District && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>District:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.District}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.Pincode && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Pincode:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Pincode}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.ContactNo && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Contact No:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.ContactNo}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.LandHoldingAcres !== undefined && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Land Holding:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.LandHoldingAcres} Acres</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Crop Information */}
                <Col md={6}>
                    <Card className="mb-3 shadow-sm border-0">
                        <Card.Header style={{ backgroundColor: '#096dd9', color: 'white', padding: '12px 20px' }}>
                            <h6 className="mb-0 d-flex align-items-center">
                                <i className="fas fa-seedling me-2"></i>
                                Crop Information
                            </h6>
                        </Card.Header>
                        <Card.Body style={{ backgroundColor: 'white' }}>
                            <table className="table table-sm table-borderless mb-0">
                                <tbody>
                                    {selectedFarmerField.CropName && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{width: '45%', paddingTop: '8px', paddingBottom: '8px'}}>Crop Name:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.CropName}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.NumberofAcresSowing !== undefined && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Acres Sowing:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.NumberofAcresSowing} Acres</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.VarietyAndCompany && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Variety & Company:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.VarietyAndCompany}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.DaysofCrop !== undefined && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Days of Crop:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.DaysofCrop} Days</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.DateOfSowing && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Date of Sowing:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{moment(parseInt(selectedFarmerField.DateOfSowing)).format("DD/MM/YYYY")}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.DeficiencyOnCrop && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Deficiency on Crop:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.DeficiencyOnCrop}</td>
                                        </tr>
                                    )}
                                    {selectedFarmerField.SuggestionbyYou && (
                                        <tr>
                                            <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Suggestions:</td>
                                            <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.SuggestionbyYou}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Demonstration Information */}
                {(selectedFarmerField.Demonstration || selectedFarmerField.Products) && (
                    <Col md={6}>
                        <Card className="mb-3 shadow-sm border-0">
                            <Card.Header style={{ backgroundColor: '#096dd9', color: 'white', padding: '12px 20px' }}>
                                <h6 className="mb-0 d-flex align-items-center">
                                    <i className="fas fa-flask me-2"></i>
                                    Demonstration Information
                                </h6>
                            </Card.Header>
                            <Card.Body style={{ backgroundColor: 'white' }}>
                                <table className="table table-sm table-borderless mb-0">
                                    <tbody>
                                        {selectedFarmerField.Demonstration && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{width: '45%', paddingTop: '8px', paddingBottom: '8px'}}>Demonstration:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Demonstration}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.Products && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Products:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Products}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.DoseofProducts && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Dose of Products:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.DoseofProducts}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.SelectedAreaForDemo && (
                                            <>
                                                {selectedFarmerField.SelectedAreaForDemo.NoOfPlants !== undefined && (
                                                    <tr>
                                                        <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>No. of Plants:</td>
                                                        <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.SelectedAreaForDemo.NoOfPlants}</td>
                                                    </tr>
                                                )}
                                                {selectedFarmerField.SelectedAreaForDemo.NoOfRows !== undefined && (
                                                    <tr>
                                                        <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>No. of Rows:</td>
                                                        <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.SelectedAreaForDemo.NoOfRows}</td>
                                                    </tr>
                                                )}
                                                {selectedFarmerField.SelectedAreaForDemo.NoOfAcres !== undefined && (
                                                    <tr>
                                                        <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>No. of Acres:</td>
                                                        <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.SelectedAreaForDemo.NoOfAcres}</td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                        {selectedFarmerField.ObservationOnPlot && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Observation on Plot:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.ObservationOnPlot}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </Col>
                )}

                {/* Field Day Information */}
                {(selectedFarmerField.FieldDay || selectedFarmerField.Crop) && (
                    <Col md={6}>
                        <Card className="mb-3 shadow-sm border-0">
                            <Card.Header style={{ backgroundColor: '#096dd9', color: 'white', padding: '12px 20px' }}>
                                <h6 className="mb-0 d-flex align-items-center">
                                    <i className="fas fa-calendar-day me-2"></i>
                                    Field Day Information
                                </h6>
                            </Card.Header>
                            <Card.Body style={{ backgroundColor: 'white' }}>
                                <table className="table table-sm table-borderless mb-0">
                                    <tbody>
                                        {selectedFarmerField.FieldDay && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{width: '45%', paddingTop: '8px', paddingBottom: '8px'}}>Field Day:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.FieldDay}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.Crop && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Crop:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Crop}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.ProductsUsed && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Products Used:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.ProductsUsed}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.ProductPurchasedFrom && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Product Purchased From:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.ProductPurchasedFrom}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.FarmersAttendance !== undefined && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Farmers Attendance:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.FarmersAttendance}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.ConductedById?.name && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Conducted By:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.ConductedById.name}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.FeedbackOnFieldDay && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Feedback:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.FeedbackOnFieldDay}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </Col>
                )}

                {/* Liquidation Information */}
                {(selectedFarmerField.Liquidation || selectedFarmerField.Product) && (
                    <Col md={6}>
                        <Card className="mb-3 shadow-sm border-0">
                            <Card.Header style={{ backgroundColor: '#096dd9', color: 'white', padding: '12px 20px' }}>
                                <h6 className="mb-0 d-flex align-items-center">
                                    <i className="fas fa-money-bill-wave me-2"></i>
                                    Liquidation Information
                                </h6>
                            </Card.Header>
                            <Card.Body style={{ backgroundColor: 'white' }}>
                                <table className="table table-sm table-borderless mb-0">
                                    <tbody>
                                        {selectedFarmerField.Liquidation && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{width: '45%', paddingTop: '8px', paddingBottom: '8px'}}>Liquidation:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Liquidation}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.FarmerDetails && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Farmer Details:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.FarmerDetails}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.Product && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Product:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Product}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.Quantity !== undefined && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Quantity:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.Quantity}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.DealerNameById?.name && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Dealer:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.DealerNameById.name}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </Col>
                )}

                {/* Farmers Meeting Information */}
                {(selectedFarmerField.FarmersMeeting || selectedFarmerField.PlaceOfMeeting) && (
                    <Col md={6}>
                        <Card className="mb-3 shadow-sm border-0">
                            <Card.Header style={{ backgroundColor: '#096dd9', color: 'white', padding: '12px 20px' }}>
                                <h6 className="mb-0 d-flex align-items-center">
                                    <i className="fas fa-users me-2"></i>
                                    Farmers Meeting Information
                                </h6>
                            </Card.Header>
                            <Card.Body style={{ backgroundColor: 'white' }}>
                                <table className="table table-sm table-borderless mb-0">
                                    <tbody>
                                        {selectedFarmerField.FarmersMeeting && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{width: '45%', paddingTop: '8px', paddingBottom: '8px'}}>Farmers Meeting:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.FarmersMeeting}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.PlaceOfMeeting && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Place of Meeting:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.PlaceOfMeeting}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.FocusedCrops && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Focused Crops:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.FocusedCrops}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.CoveredVillages && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Covered Villages:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.CoveredVillages}</td>
                                            </tr>
                                        )}
                                        {selectedFarmerField.MeetingConductedById?.name && (
                                            <tr>
                                                <td className="fw-bold text-muted" style={{paddingTop: '8px', paddingBottom: '8px'}}>Meeting Conducted By:</td>
                                                <td style={{paddingTop: '8px', paddingBottom: '8px'}}>{selectedFarmerField.MeetingConductedById.name}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </Col>
                )}

            </Row>
        )}
    </Modal.Body>
    <Modal.Footer style={{ borderTop: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
        <Button 
            variant="outline-secondary" 
            onClick={() => setShowFarmerFieldModal(false)}
            style={{ minWidth: '100px' }}
        >
            Close
        </Button>
    </Modal.Footer>
</Modal>


            {/* Details Modal */}
            <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Farmer Activity Details</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {loadingDetails ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                            <div className="spinner-border text-primary m-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <Row>
                            <Col md={6}>
                                <Card>
                                    <Card.Header>
                                        <h5>Crop Data</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        {cropData.length > 0 ? (
                                            <div className="table-responsive">
                                                <table className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            {Object.keys(cropData[0]).map((key) => (
                                                                <th key={key}>{key}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {cropData.map((item, index) => (
                                                            <tr key={index}>
                                                                {Object.values(item).map((value, i) => (
                                                                    <td key={i}>{typeof value === 'object' ? JSON.stringify(value) : String(value)}</td>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <p>No crop data available</p>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6}>
                                <Card>
                                    <Card.Header>
                                        <h5>Demonstration Data</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        {demonstrationData.length > 0 ? (
                                            <div className="table-responsive">
                                                <table className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            {Object.keys(demonstrationData[0]).map((key) => (
                                                                <th key={key}>{key}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {demonstrationData.map((item, index) => (
                                                            <tr key={index}>
                                                                {Object.values(item).map((value, i) => (
                                                                    <td key={i}>{typeof value === 'object' ? JSON.stringify(value) : String(value)}</td>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <p>No demonstration data available</p>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    )

}

export default FarmerProfile;
